module.exports = __webpack_public_path__ + "static/media/burgeon_logo.66829080.png";